var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.67749 9.7888L6.49219 8.92188M8.67749 14.2859L6.49219 13.419M12.25 8.3711V20.476M3.25 10.9207V5.74981C3.25 4.37792 4.45065 3.32614 5.81378 3.475C8.02535 3.71727 9.93627 4.62117 11.0883 5.2896C11.8092 5.707 12.6908 5.707 13.4117 5.2896C14.5637 4.62117 16.4746 3.71727 18.6862 3.475C20.0503 3.32614 21.25 4.37792 21.25 5.74981V16.0915C21.25 17.3097 20.2906 18.2827 19.0754 18.3702C16.6994 18.5415 14.6309 19.5135 13.4117 20.2199C12.6908 20.6373 11.8092 20.6373 11.0883 20.2199C9.86913 19.5135 7.80059 18.5415 5.42459 18.3702C4.20935 18.2827 3.25 17.3097 3.25 16.0915V15.2059",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#3A3B45"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.63d1b836574a4d73a11c85990e88a403.svg";
export { ForwardRef as ReactComponent };